import { axios } from "@LIBS";
import { Constants } from "@CONFIG";

const DeliveryEndpoints = {
  preOrderDeliveries: "api/deliveries/pre-order",
  operationDeliveries: "api/deliveries/operation",
  getDeliveryTracking: "api/deliveries",
};

const createDelivery = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries`,
    method: "POST",
    data: values,
  });

  return response;
};

const uploadPdf = async (formData, onUploadProgress) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/upload-pdf`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    // Yükleme yüzdesini yakalamak için gerekli
    onUploadProgress: onUploadProgress,
  });

  return response;
};

const uploadExcel = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/upload`,
    method: "POST",
    data: values,
  });

  return response;
};

const updateDelivery = async (values, id) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/${id}`,
    method: "PUT",
    data: values,
  });

  return response;
};

const deleteDelivery = async (id) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/${id}`,
    method: "DELETE",
  });

  return response;
};

const deleteDeliveryWithoutMessage = async (id) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/${id}`,
    method: "DELETE",
    hideSuccessMessage: true,
    hideErrorMessageFromServer: true,
  });

  return response;
};

const deleteDeliveryInOperation = async (delivery) => {
  let id = delivery.customerDeliveryNo;
  if (delivery.type === "RETURNED") {
    id += "-RETURNED";
  }
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/${id}/cancel`,
    method: "POST",
  });

  return response;
};

const recallDeliveryInOperation = async (delivery) => {
  const id = delivery.customerDeliveryNo;

  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/${id}/recall`,
    method: "POST",
  });

  return response;
};

const printBarcode = async (arr) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/print`,
    method: "POST",
    data: {
      deliveryList: arr,
    },
    hideSuccessMessage: true,
  });

  return response;
};

const packageDeliveries = async (deliveryId) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/${deliveryId}/package`,
    method: "PUT",
    data: deliveryId,
    hideSuccessMessage: true,
  });

  return response;
};

const packageDeliveryWithoutMessage = async (deliveryId, excel) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/${deliveryId}/package${
      excel ? "?excel=true" : ""
    }`,
    method: "PUT",
    data: deliveryId,
    hideSuccessMessage: true,
    hideErrorMessageFromServer: true,
  });

  return response;
};
const autoPackageDeliveryWithoutMessage = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/package`,
    method: "POST",
    data: values,
    hideSuccessMessage: true,
    hideErrorMessageFromServer: true,
  });

  return response;
};

const autoPackagePrintBarcode = async (arr) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/autoPackage-print`,
    method: "POST",
    data: {
      deliveryList: arr,
    },
    hideSuccessMessage: true,
  });

  return response;
};
const previewFile = async (url) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/${url}`,
    method: "GET",
    hideSuccessMessage: true,
    responseType: "blob",
  });

  return response;
};

const getDeliveryPhotos = async (barcode) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/deliveries/${barcode}/photos`,
    method: "GET",
    hideSuccessMessage: true,
  });

  return response;
};

export {
  DeliveryEndpoints,
  deleteDelivery,
  deleteDeliveryWithoutMessage,
  uploadExcel,
  deleteDeliveryInOperation,
  createDelivery,
  updateDelivery,
  printBarcode,
  packageDeliveries,
  packageDeliveryWithoutMessage,
  autoPackageDeliveryWithoutMessage,
  recallDeliveryInOperation,
  autoPackagePrintBarcode,
  uploadPdf,
  previewFile,
  getDeliveryPhotos,
};
